import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import circularEco from '../../images/source-separation-systems-circular-economy.svg';
import {
  DESC,
  DIMENSIONS,
  ACCESSORIES,
  CUSTOMISE,
  CIRCULAR_ECO,
  CPDIMENSIONS,
} from './tablabels';
import {
  COLOR_LIGHT_GRAY,
  COLOR_BORDER_GRAY,
  COLOR_GRAY,
  COLOR_GREEN,
  MAIN_HEADING_FONT,
  screen,
  StyledA,
} from '../common/variables';
import { removeNBSP, stripLastSlash } from '../common/functions';

const TabTextContainer = styled.div`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid ${COLOR_LIGHT_GRAY};
  p {
    margin-bottom: 10px;
  }
`;
const TabTextContent = styled.div`
  background-color: white;
  padding: 1rem;
  min-height: 280px;
  /* height: initial; */
  .description-container {
    @media ${screen.medium} {
      padding: 1rem;
    }
  }
  @media ${screen.large} {
    padding: 0.5rem;
  }
  position: relative;
  font-size: 1rem;
  color: #808080;
  p {
    margin-bottom: 10px;
    line-height: 1.3rem;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    color: ${COLOR_GRAY};
    th {
      border-right: 1px solid ${COLOR_BORDER_GRAY};
      padding: 1rem;
    }
    th:last-of-type {
      border-right: 0;
    }
  }

  .dimensions-container {
    padding: 2rem;
  }

  .mobile-content-accessories {
    display: block;
    justify-content: space-between;
    @media ${screen.medium} {
      display: flex;
    }

    .texts-container {
      max-width: 430px;
      align-self: center;
      margin-left: 5px;
      margin-right: 5px;
      @media ${screen.medium} {
        margin-left: 15px;
        margin-right: 15px;
      }
    }

    .row__text-header {
      margin-top: 5px;
      margin-bottom: 12px;
    }

    .accessories-images {
      max-width: 300px;
      width: 100%;
      margin: 0 auto;
      @media ${screen.medium} {
        max-width: 250px;
      }
    }

    .customise-images {
      max-width: 200px;
      margin: 0 auto;
    }

    .accessories-product-link {
      border-bottom: 0;
      margin-top: 17px;
      font-size: 0.95rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .customise-tab-container {
    .texts-on-mobile {
      display: block;
      justify-content: space-between;
      min-height: 340px;
      @media ${screen.medium} {
        display: flex;
      }
      .texts-container {
        max-width: 430px;
        margin-left: 15px;
      }

      .row__text-header {
        margin-top: 5px;
        margin-bottom: 12px;
      }

      .customise-images {
        max-width: 250px;
        width: 100%;
        height: 90%;
        margin: 0 auto;
      }
    }
  }
  .compost-a-pak-demensions-desktop {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    height: 100%;

    &__selection-column {
      width: 30%;
      min-height: 250px;
      padding: 16px 32px;

      ol {
        list-style-type: none;
        padding: 0;
        margin: 0;
      }
    }

    &__image-column {
      width: 70%;
      display: flex;
      height: 100%;
      margin: 20px;
      flex-direction: column;

      .image-container {
        width: 100%;
        justify-content: space-around;
        align-items: center;
        display: flex;

        .main-image {
          width: 73%;
          height: auto;
        }

        .secondary-image {
          width: 39%;
          height: auto;
        }
      }
    }

    h2 {
      margin-bottom: 10px;
    }

    p {
      text-align: left;
      margin: 20px 10px 0px 20px;
      font-style: italic;
      font-size: 0.8rem;
    }
  }

  .compost-a-pak-demensions-mobile {
    &__content {
      width: 100%;
      justify-content: space-around;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    img {
      width: 100%;
      max-width: 250px;
    }

    p {
      text-align: left;
      margin: 20px 10px 0px 20px;
      font-style: italic;
      font-size: 0.8rem;
    }
  }
`;

const TableRow = styled.tr`
  border-top: 1px solid ${COLOR_BORDER_GRAY};
  td {
    border-right: 1px solid ${COLOR_BORDER_GRAY};
    text-align: center;
    vertical-align: middle;
  }
  td:last-of-type {
    border-right: 0;
  }
  .image {
    min-height: 100px;
    min-width: 100px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid ${COLOR_BORDER_GRAY};
  &:first-of-type {
    border-top: 0;
  }
  > span,
  > div {
    flex: 1;
  }
  > span {
    max-width: 200px;
  }
  .thumbnail {
    width: 100px;
    display: inline-block;
  }
  .row__textbox:not(:first-child) {
    padding: 2rem;
    padding-bottom: 1.5rem;
  }
  .row__textbox::last-child {
    padding-bottom: 0px;
  }
  .row__text-content {
    padding: 1rem 0rem 1rem 1rem;
  }
  .row__text-header {
    padding-left: 1rem;
  }

  .accessories-product-link {
    border-bottom: 0;
    margin-top: 17px;
    padding-left: 16px;
    font-size: 0.95rem;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const CustomiseWrapper = styled.div`
  margin-bottom: 62px;

  .row__text-header {
    padding-left: 0;
    margin-bottom: 0.8rem;
  }
`;

const MobileDimensionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1.6rem 0rem;
  width: 100%;
  font-size: 1.1rem;

  .rows-container {
    width: 100%;
    .row {
      border-bottom: 1px solid rgba(128, 128, 128, 0.6);
      display: flex;
      padding: 3px 0px;
      margin: 10px 0px;
      justify-content: space-between;
      width: 100%;
      &:first-child {
        color: #69ad3f;
      }
    }
  }
`;

const Contact = styled.div`
  display: none;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  line-height: 80px;
  background-color: ${COLOR_GREEN};
  color: white;
  text-align: center;
  display: none;
  justify-content: center;
  margin-top: 3rem;
  position: absolute;
  @media ${screen.largeXL} {
    position: absolute;
  }

  .text {
    margin-right: calc(5% + 25px);
  }

  align-items: center;
  ${MAIN_HEADING_FONT}
  @media ${screen.large} {
    display: flex;
    a {
      margin-right: 20px;
      background: #fff;
      border: 0;
      &:hover {
        border: 0;
        color: #fff !important;
      }
    }
  }
`;

const ContactMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  text-align: center;
  @media ${screen.large} {
    display: none;
  }
  a {
    color: #fff !important;
    margin-top: 15px;
    margin-bottom: 30px;
  }
`;

const CircularEcoContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  @media ${screen.large} {
    padding: 1.8rem;
  }
  justify-content: space-between;
  svg {
    width: 300px;
    margin-left: -30px;
    margin-top: -30px;
  }
  div {
    @media ${screen.large} {
      padding-left: 30px;
    }
  }

  .st0 {
    fill: #6cb33f;
  }

  .st1 {
    fill: #006838;
  }
`;

const SelectionItem = styled.li`
  padding: 3px 0px;
  &:hover {
    cursor: pointer;
  }
  width: fit-content;
  margin: 17px 0px;
`;

export class TabContent extends React.Component {
  state = {
    selectedProduct: null,
    selectedProductMobile: null,
  };

  renderContent = (tab, content, mobile) => {
    switch (tab) {
      case DESC:
        return (
          <div
            className="description-container"
            dangerouslySetInnerHTML={{ __html: removeNBSP(content) }}
          />
        );
      case CPDIMENSIONS: {
        const products = content;
        if (!products || products.length < 1 || !products[0].dimensionImage) {
          return null;
        }
        let { selectedProduct, selectedProductMobile } = this.state;
        if (!selectedProduct) selectedProduct = products[0];

        if (mobile) {
          if (!selectedProductMobile) selectedProductMobile = products[0];

          return (
            <div className="compost-a-pak-demensions-mobile">
              {products.length > 1 ? (
                <select
                  value={selectedProductMobile.title}
                  onChange={(e) =>
                    this.setState({
                      selectedProductMobile: products.find(
                        (p) => p.title === e.target.value
                      ),
                    })
                  }
                >
                  {products.map((p, index) => (
                    <option key={index} value={p.title}>
                      {p.title}
                    </option>
                  ))}
                </select>
              ) : null}
              <div className="compost-a-pak-demensions-mobile__content">
                <img
                  src={
                    selectedProductMobile.dimensionImage.localFile
                      .childImageSharp.gatsbyImageData.images.fallback.src
                  }
                  alt={selectedProductMobile.dimensionImage.title}
                />
                {selectedProductMobile.secondaryImage && (
                  <img
                    key={
                      selectedProductMobile.secondaryImage.localFile
                        .childImageSharp.gatsbyImageData.images.fallback.src
                    }
                    src={
                      selectedProductMobile.secondaryImage.localFile
                        .childImageSharp.gatsbyImageData.images.fallback.src
                    }
                    alt={selectedProductMobile.secondaryImage.title}
                  />
                )}
              </div>
              <p>{selectedProductMobile.dimensions}</p>
            </div>
          );
        }

        return (
          <div className="compost-a-pak-demensions-desktop">
            <div className="compost-a-pak-demensions-desktop__selection-column">
              <ol>
                <h2>Size Selection</h2>
                {products.map((p) => (
                  <SelectionItem
                    key={p.title}
                    onClick={() => this.setState({ selectedProduct: p })}
                    style={
                      selectedProduct.title !== p.title
                        ? {}
                        : {
                            borderBottom: '2px solid #69ad3f',
                            color: '#69ad3f',
                          }
                    }
                  >
                    {p.title}
                  </SelectionItem>
                ))}
              </ol>
            </div>
            <div className="compost-a-pak-demensions-desktop__image-column">
              <div className="image-container">
                <GatsbyImage
                  className="main-image"
                  image={
                    selectedProduct.dimensionImage.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  alt="c"
                />

                {selectedProduct.secondaryImage && (
                  <GatsbyImage
                    className="secondary-image"
                    image={
                      selectedProduct.secondaryImage.localFile.childImageSharp
                        .gatsbyImageData
                    }
                    alt="c"
                  />
                )}
              </div>
              <p>{selectedProduct.dimensions}</p>
            </div>
          </div>
        );
      }
      case DIMENSIONS:
        // This case, content will be an array of dimensions data
        if (!content) {
          return <div>No Dimensions.</div>;
        }
        return mobile ? (
          <div>
            {content.map((dimension, index) => (
              <div key={index}>
                <MobileDimensionsContainer>
                  <div className="rows-container">
                    <div className="row">
                      <span>Product Code</span>
                      <span>{dimension.dimesionsPCode}</span>
                    </div>
                    <div className="row">
                      <span>Volume</span>
                      <span> {dimension.detailVol === null ? 'N/A' : dimension.detailVol + ' Litres'}</span>
                    </div>
                    <div className="row">
                      <span>Height</span>
                      <span> {dimension.height === null ? 'N/A' : dimension.height + ' mm'}</span>
                    </div>
                    <div className="row">
                      <span>Width</span>
                      <span> {dimension.width === null ? 'N/A' : dimension.width + ' mm'}</span>
                    </div>
                    <div className="row">
                      <span>Depth</span>
                      <span>{dimension.depth === null ? 'N/A' : dimension.depth + ' mm'}</span>
                    </div>
                  </div>
                </MobileDimensionsContainer>
              </div>
            ))}
          </div>
        ) : (
          <div className="dimensions-container">
            <table>
              <thead>
                <tr>
                  <th> </th>
                  <th>Product Code</th>
                  <th>Volume</th>
                  <th>Height</th>
                  <th>Width</th>
                  <th>Depth</th>
                </tr>
              </thead>
              <tbody>
                {content.map((dimension, index) => (
                  <TableRow key={index}>
                    <td className="image">
                      <GatsbyImage
                        className="secondary-image"
                        image={
                          dimension.image.localFile.childImageSharp
                            .gatsbyImageData
                        }
                        alt="c"
                      />
                    </td>
                    <td>{dimension.dimesionsPCode}</td>
                    <td>{dimension.detailVol === null ? 'N/A' : dimension.detailVol + ' Litres'}</td>
                    <td>{dimension.height === null ? 'N/A' : dimension.height + ' mm'}</td>
                    <td>{dimension.width === null ? 'N/A' : dimension.width + ' mm'}</td>
                    <td>{dimension.depth === null ? 'N/A' : dimension.depth + ' mm'}</td>
                  </TableRow>
                ))}
              </tbody>
            </table>
          </div>
        );

      case ACCESSORIES:
        if (mobile) {
          return content.map((choice, index) => (
            <div className="mobile-content-accessories" key={index}>
              {choice.image && (
                <GatsbyImage
                  className="accessories-images"
                  image={choice.image.localFile.childImageSharp.gatsbyImageData}
                  alt="c"
                />
              )}
              <div className="texts-container">
                <div
                  className="row__text-header"
                  dangerouslySetInnerHTML={{ __html: choice.header }}
                />

                <div
                  className="row__text-content"
                  dangerouslySetInnerHTML={{
                    __html: removeNBSP(choice.description),
                  }}
                />

                {choice.productLink && (
                  <Link
                    className="accessories-product-link"
                    to={
                      choice.productLink.uri.split('/')[1] === 'cp_prodcut'
                        ? `/compost-a-pak/${stripLastSlash(
                            choice.productLink.uri
                          )}`
                        : `/product/${stripLastSlash(choice.productLink.uri)}`
                    }
                  >
                    View accessory
                  </Link>
                )}
              </div>
            </div>
          ));
        }
        return content.map((choice, index) => (
          <Row key={index}>
            <span className="thumbnail">
              {choice.image && (
                <GatsbyImage
                  image={choice.image.localFile.childImageSharp.gatsbyImageData}
                  alt="c"
                />
              )}
            </span>
            <div className="row__textbox">
              <div
                className="row__text-header"
                dangerouslySetInnerHTML={{ __html: choice.header }}
              />
              <div
                className="row__text-content"
                dangerouslySetInnerHTML={{
                  __html: removeNBSP(choice.description),
                }}
              />
              {choice.productLink && (
                <Link
                  className="accessories-product-link"
                  to={
                    choice.productLink.uri.split('/')[1] === 'cp_prodcut'
                      ? `/compost-a-pak/${stripLastSlash(
                          choice.productLink.uri
                        )}`
                      : `/product/${stripLastSlash(choice.productLink.uri)}`
                  }
                >
                  View accessory
                </Link>
              )}
            </div>
          </Row>
        ));
      case CUSTOMISE:
        if (mobile)
          return (
            <div className="customise-tab-container">
              {content.map((choice, index) => (
                <div
                  className="texts-on-mobile"
                  key={`${choice.description} ${index}`}
                >
                  {choice.image && (
                    <GatsbyImage
                      className="customise-images"
                      image={
                        choice.image.localFile.childImageSharp.gatsbyImageData
                      }
                      alt="c"
                    />
                  )}
                  <div className="texts-container">
                    <div
                      className="row__text-header"
                      dangerouslySetInnerHTML={{ __html: choice.header }}
                    />
                    <div
                      className="row__text-content"
                      dangerouslySetInnerHTML={{ __html: choice.description }}
                    />
                  </div>
                </div>
              ))}
              <ContactMobile>
                Get in touch to customise your product{' '}
                <StyledA href="tel:1300739913">Call 1300 739 913</StyledA>
              </ContactMobile>

              <Contact className="contact">
                <div className="text">
                  Get in touch to customise your product{' '}
                </div>

                <StyledA href="tel:1300739913">Call 1300 739 913</StyledA>
              </Contact>
            </div>
          );
        return (
          <CustomiseWrapper>
            {content.map((choice, index) => (
              <Row className="customise" key={choice.image.title + index}>
                <span className="thumbnail">
                  <GatsbyImage
                    image={
                      choice.image.localFile.childImageSharp.gatsbyImageData
                    }
                    alt="c"
                  />
                </span>

                <div className="row__textbox">
                  <div
                    className="row__text-header"
                    dangerouslySetInnerHTML={{ __html: choice.header }}
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: choice.description }}
                  />
                </div>
              </Row>
            ))}
            <Contact className="contact">
              <div className="text">
                Get in touch to customise your product{' '}
              </div>

              <StyledA href="tel:1300739913">Call 1300 739 913</StyledA>
            </Contact>
          </CustomiseWrapper>
        );
      case CIRCULAR_ECO:
        if (mobile) {
          return (
            <CircularEcoContainer>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </CircularEcoContainer>
          );
        }
        return (
          <CircularEcoContainer>
            <SVG src={circularEco} className="circular-eco-svg" />
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </CircularEcoContainer>
        );
      default:
        console.warn('[Alert] No corresponding tab');
    }
  };
  render() {
    const { props } = this;

    return (
      <TabTextContainer>
        <TabTextContent>
          {this.renderContent(props.tab, props.content, props.mobile)}
        </TabTextContent>
      </TabTextContainer>
    );
  }
}
